/**
 * Scroll to a section by DOM id and sync the URL hash.
 * @param {string} sectionId - Element id (matches hash without #)
 * @param {{ behavior?: ScrollBehavior, updateHash?: boolean }} [options]
 */
export function scrollToSection(sectionId, options = {}) {
  const { behavior = "smooth", updateHash = true } = options;
  const element = document.getElementById(sectionId);

  if (!element) {
    return false;
  }

  element.scrollIntoView({ behavior });
  if (updateHash) {
    window.history.replaceState(null, "", `#${sectionId}`);
  }

  return true;
}

/** React click handler for in-page section links. */
export function createScrollHandler(sectionId, options = {}) {
  return (event) => {
    event.preventDefault();
    scrollToSection(sectionId, options);
  };
}

/** Scroll to hash on first load / direct link (e.g. /#contact). */
export function scrollToInitialHash(options = {}) {
  const hash = window.location.hash.slice(1);
  if (!hash) {
    return false;
  }

  const { behavior = "auto", ...rest } = options;
  return scrollToSection(hash, { behavior, ...rest });
}
